/** @format */
import { Injectable } from '@angular/core';
import { DowngradedService, ModalService, ServiceDowngradeMappings, StaticMembers } from 'sis-common';
import { ConfirmDialogComponent, ConfirmDialogValues } from './confirm-dialog.component';

/**
 * @deprecated Use {@link getConfirmationModalOpener} instead to open the confirmation dialog modal.
 */
@StaticMembers<DowngradedService>()
@Injectable({
    providedIn: 'root',
})
export class ConfirmDialogService {
    static downgrade: ServiceDowngradeMappings = {
        moduleName: 'sis-components.service.confirmDialogService',
        serviceName: 'confirmDialogService',
    };

    constructor(private modalService: ModalService) {}

    /**
     * The returned {@link Promise} will get rejected, if the dialog is closed without a confirmation.
     */
    confirm(values: ConfirmDialogValues<any>, keepOpenOnPopstate?: boolean): Promise<any> {
        return this.modalService.open(ConfirmDialogComponent, values, {
            windowClass: 'confirm-dialog',
            size: 'sm',
            keepOpenOnPopstate: keepOpenOnPopstate || false,
        }).result;
    }
}
